// @core/api/endpoints/analytics/list_reports.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListReportsResponse,
} from '../../../types/analytics';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/analytics';

/**
 * List reports
 * Returns all reports. Supports filtering by type, status, and format.
 */
export async function ListReports(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListReportsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics/reports`;
  const requestOptions = options;
  return client.get<ListReportsResponse>(requestPath, { ...requestOptions, params });
}
